// src/helpers/getHomeElementIdsByBucket.ts
var typeMap = {
  item: "items",
  combo: "combos",
  menu: "menuTypes",
  category: "categories",
  subcategory: "subcategories",
  "modifier-item": "modifierItems"
};
var getHomeElementsByBucket = (elements) => {
  const homeElementIds = {
    items: [],
    combos: [],
    menuTypes: [],
    categories: [],
    subcategories: [],
    modifierItems: [],
    general: []
  };
  elements.forEach((element) => {
    homeElementIds[element.type in typeMap ? typeMap[element.type] : "general"].push(element);
  });
  return homeElementIds;
};
var getHomeElementSpacesByBucket = (elements) => {
  const homeElementsSpaces = {
    items: {},
    combos: {},
    menuTypes: {},
    categories: {},
    subcategories: {},
    modifierItems: {},
    general: {}
  };
  elements.forEach((element) => {
    homeElementsSpaces[element.type in typeMap ? typeMap[element.type] : "general"][element.id] = element.spacesBefore;
  });
  return homeElementsSpaces;
};

export { getHomeElementSpacesByBucket, getHomeElementsByBucket };
